import {Component, inject, OnDestroy, OnInit, resource} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CartegraphManagementService} from '../../../../../data/cartegraph/cartegraph-management.service';
import {Router} from '@angular/router';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {CardComponent} from '../../../../../shared/components/card/card.component';
import {CardContentDirective} from '../../../../../shared/components/card/card-content.directive';
import {MatIcon} from '@angular/material/icon';
import {MatActionList, MatDivider, MatListItem, MatListItemTitle} from '@angular/material/list';

@Component({
  selector: 'app-cartegraph-settings-import-filters',
  templateUrl: './cartegraph-settings-resources.component.html',
  styleUrls: ['../../../settings-fields.scss',
    '../../../settings-common.scss',
    './cartegraph-settings-resources.scss'
  ],
  imports: [
    MatProgressSpinner,
    CardComponent,
    ReactiveFormsModule,
    CardContentDirective,
    MatIcon,
    MatListItem,
    MatListItemTitle,
    MatDivider,
    MatActionList,
  ],
  standalone: true
})
export class CartegraphSettingsResourcesComponent implements OnInit, OnDestroy {

  private cartegraphManagementService = inject(CartegraphManagementService);
  private router = inject(Router);

  materialResource = resource({
    loader: () => this.cartegraphManagementService.getMaterialList()
  });

  materialLocationResource = resource({
    loader: () => this.cartegraphManagementService.getMaterialLocationList()
  });

  vehicleAttachmentResource = resource({
    loader: () => this.cartegraphManagementService.getAttachmentList()
  });

  constructor() {
  }

  ngOnInit(): void {
    return;
  }

  ngOnDestroy(): void {
    return;
    // this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  navigateBack() {
    this.router.navigate(['settings', 'cartegraph-settings', 'settings']).then();
  }

}
